import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgIf } from "@angular/common";

import {
    AUDIENCE_ICONS,
    AUDIENCE_LABELS,
    Audience,
} from "../../models/event.models";

@Component({
    selector: "app-audience-pill",
    standalone: true,
    imports: [NgIf],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./audience-pill.component.html",
    styleUrl: "./audience-pill.component.scss",
})
export class AudiencePillComponent {
    @Input({ required: true }) audience!: Audience;
    /** Renders on a dark photo scrim instead of a light surface. */
    @Input() onImage = false;

    get label(): string {
        return AUDIENCE_LABELS[this.audience] ?? this.audience;
    }

    get icon(): string {
        return AUDIENCE_ICONS[this.audience] ?? "groups";
    }
}
